import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import StyledWeather from '../styles/Weather';

const Weather = ({ currentWeather, timezone }) => {
  const {
    weather,
    temp,
    sunrise,
    sunset,
    wind_speed,
    clouds,
    visibility,
    dew_point,
  } = currentWeather;

  let imgSrc = '';
  imgSrc = `http://openweathermap.org/img/wn/${weather[0].icon}@2x.png`;

  const formattedSunsise = moment.unix(sunrise).format('HH.mm');
  const formattedSunset = moment.unix(sunset).format('HH.mm');

  return (
    <StyledWeather>
      <h1>{timezone}</h1>

      <div className='weather-overview'>
        <h3>{temp} &deg;</h3>
        <img src={imgSrc} alt="Weather Icon" />
      </div>

      <div className='weather-detail'>
        <div className='detail'>
          <div>
            <h4>Sunrise</h4>
            <p>{formattedSunsise}</p>
          </div>

          <div>
            <h4>Sunset</h4>
            <p>{formattedSunset}</p>
          </div>
        </div>

        <div className='detail'>
          <div>
            <h4>Wind</h4>
            <p>{wind_speed} mph</p>
          </div>

          <div>
            <h4>Cloud</h4>
            <p>{clouds} octa</p>
          </div>
        </div>

        <div className='detail'>
          <div>
            <h4>Visibility</h4>
            <p>{visibility} metres</p>
          </div>

          <div>
            <h4>Dew Point</h4>
            <p>{dew_point}&deg; C</p>
          </div>
        </div>
      </div>
    </StyledWeather>
  );
};

Weather.propTypes = {
  currentWeather: PropTypes.shape({}).isRequired,
  timezone: PropTypes.string.isRequired,
};

export default Weather;
